/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { Button } from 'antd';

type OwnProps = {
  onClick?: (...args: any[]) => any;
  count?: number;
};

type State = any;

type Props = OwnProps & typeof CountdownButton.defaultProps;

class CountdownButton extends React.PureComponent<Props, State> {
  static defaultProps = {
    onClick: () => {},
    count: 60,
  };

  interval: any;

  state = {
    status: 'enabled',
    count: this.props.count,
    buttonText: '发送验证码',
  };

  componentDidMount() {
    const loginMessageCount = localStorage.getItem('loginMessageCount');

    if (loginMessageCount) {
      try {
        const { count, time } = JSON.parse(loginMessageCount);
        const currentTime = new Date().getTime();
        const interval = Math.round((currentTime - time) / 1000);

        if (interval < count) {
          this.setState({ count: count - interval }, () => {
            this.startCountdown();
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleClick = () => {
    this.props.onClick();
  };

  startCountdown = () => {
    const { count, status } = this.state;
    if (status === 'enabled') {
      this.interval = setInterval(() => this.countdown(), 1000);
      this.setState({ status: 'disabled', buttonText: `重新发送(${count}s)` });
    }
  };

  countdown = () => {
    let { count } = this.state;

    count -= 1;
    if (count > 0) {
      this.setState({ count, buttonText: `重新发送(${count}s)` });
      localStorage.setItem(
        'loginMessageCount',
        JSON.stringify({ count, time: new Date().getTime() })
      );
    } else {
      clearInterval(this.interval);
      this.setState({
        status: 'enabled',
        count: this.props.count,
        buttonText: '发送验证码',
      });
    }
  };

  render() {
    const { buttonText, status } = this.state;

    return (
      <Button
        type="primary"
        className="code-send-btn"
        disabled={status === 'disabled'}
        onClick={this.handleClick}
      >
        {buttonText}
      </Button>
    );
  }
}

export default CountdownButton;
